import { createContext } from 'react';
import type { ConsentDecision } from './consentStore';

export interface ConsentContextValue {
    ready: boolean;
    decision: ConsentDecision | null;
    bannerOpen: boolean;
    settingsOpen: boolean;
    acceptAll: () => void;
    rejectAll: () => void;
    save: (analytics: boolean) => void;
    openSettings: () => void;
}

export const ConsentContext = createContext<ConsentContextValue | null>(null);
